import { TableKey } from '@sparkplug/lib';

export const getTableSettingsCacheKey = (tableKey: TableKey) => ['tableKey', tableKey];
